var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1174L11.0915 10.2089C12.1067 8.96717 12.6059 7.38272 12.4858 5.78327C12.3656 4.18382 11.6352 2.69175 10.4458 1.61568C9.25638 0.539605 7.69886 -0.0381362 6.0954 0.00195526C4.49195 0.0420467 2.96524 0.696903 1.83107 1.83107C0.696903 2.96524 0.0420467 4.49195 0.00195526 6.0954C-0.0381362 7.69886 0.539605 9.25638 1.61568 10.4458C2.69175 11.6352 4.18382 12.3656 5.78327 12.4858C7.38272 12.6059 8.96717 12.1067 10.2089 11.0915L14.1174 15L15 14.1174ZM6.26165 11.255C5.27406 11.255 4.30865 10.9621 3.4875 10.4135C2.66635 9.86479 2.02634 9.08494 1.64841 8.17252C1.27047 7.26011 1.17159 6.25611 1.36426 5.2875C1.55693 4.31889 2.0325 3.42916 2.73083 2.73083C3.42916 2.0325 4.31889 1.55693 5.2875 1.36426C6.25611 1.17159 7.26011 1.27047 8.17252 1.64841C9.08494 2.02634 9.86479 2.66635 10.4135 3.4875C10.9621 4.30865 11.255 5.27406 11.255 6.26165C11.2535 7.58551 10.7269 8.85473 9.79084 9.79084C8.85473 10.7269 7.58551 11.2535 6.26165 11.255Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.cdf0d98f1e4e26637bbeae153541e190.svg";
export { ForwardRef as ReactComponent };